import * as React from "react";

const SvgSpeaker = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      id="speaker_svg__a"
      d="M20.481 9.772a1.407 1.407 0 01-1.989 1.989L9.132 2.4a1.41 1.41 0 010-1.99 1.411 1.411 0 011.99 0l9.36 9.362zM8.437 3.694l8.762 8.761-.354.07c-2.483.498-4.809 1.736-6.72 3.367L5.032 10.8C6.664 8.888 7.87 6.53 8.366 4.047l.07-.353zm-4.338 8.16l4.971 4.972-3.48 3.48a2.11 2.11 0 01-2.983 0L.618 18.318a2.11 2.11 0 010-2.984l3.48-3.48zm7.907 8.826l.75.727a1.408 1.408 0 01-1.988 1.99l-3.19-3.09 1.99-1.99 1.428 1.385.972-.972a.702.702 0 000-.994l-.848-.85c.365-.306.74-.592 1.132-.856l.71.711a2.108 2.108 0 010 2.983l-.956.956z"
    />
  </svg>
);

export default SvgSpeaker;
